import { MEDIUM_VIEWPORT_QUERY, SMALL_VIEWPORT_QUERY } from "config/constants";
import { useMediaQuery } from "./useMediaQuery";

/** Whether the small screen layout is used (a viewport up to `SMALL_VIEWPORT_MAX_WIDTH` wide) */
export const useIsSmallViewport = () => useMediaQuery(SMALL_VIEWPORT_QUERY);

/** Whether the viewport is at most `MEDIUM_VIEWPORT_MAX_WIDTH` wide (e.g. lower modals) */
export const useIsMediumViewport = () => useMediaQuery(MEDIUM_VIEWPORT_QUERY);
